import classNames from "classnames";
import React from "react";

import { WSIcon, WSIconName, WSText } from "../core";
import {
  WSElement,
  WSElementColorsType,
  WSElementProps
} from "../WSElement/WSElement.component";

import styles from "./WSInfoBox.module.scss";

export type WSInforBoxSize = "S" | "M";

export type WSInfoBoxProps = {
  theme?: "info" | "warning" | "neutral";
  title?: string;
  size?: WSInforBoxSize;
  transparent?: boolean;
  icon?: WSIconName;
  iconColor?: WSElementColorsType;
} & WSElementProps;

export const WSInfoBox: React.FC<WSInfoBoxProps> = ({
  title,
  children,
  className,
  size = "M",
  transparent,
  theme,
  icon,
  colorBackground = "gray50",
  iconColor = "gray600",
  ...elementProps
}) => {
  return (
    <WSElement
      className={classNames(
        styles.infobox,
        styles[`size-${size}`],
        theme && styles[`theme-${theme}`],
        transparent && styles.transparent,
        className
      )}
      colorBackground={colorBackground}
      {...elementProps}
    >
      {icon && <WSIcon name={icon} size={size} color={iconColor} mr="S" />}
      <WSElement className={styles.content}>
        {title && (
          <WSText
            kind={size === "S" ? "ParagraphXs" : "ParagraphSm"}
            weight="medium"
            mb={size === "S" ? "NONE" : "XS"}
            className={styles.title}
          >
            {title}
          </WSText>
        )}
        {children}
      </WSElement>
    </WSElement>
  );
};
